export const alcaldiasRouter = [
    {
        path: 'alcaldias/list',
        name: 'Alcaldias list',
        component: () => import('./pages/list')
    }, {
        path: 'alcaldias/registrar',
        name: 'Alcaldias Registrar',
        component: () => import('./pages/registraAlcaldia')
    }, {
        path: 'alcaldias/detalle/:id',
        name: 'Alcaldias detalle',
        component: () => import('./pages/alcaldiaDetalle')
    },{
        path: 'alcaldias/editar/:id',
        name: 'Alcaldias editar',
        component: () => import('./pages/editarAlcaldia')
    },
]